module.exports = require('i18next-http-backend')
